import type { Category, CategoryId } from "./api";
import { intlLocale } from "./i18n";

export const DEFAULT_CATEGORIES: Category[] = [
  { id: "food", label: "Ushqim", emoji: "🍔", order: 0 },
  { id: "trans", label: "Transport", emoji: "🚌", order: 1 },
  { id: "bills", label: "Faturat", emoji: "💡", order: 2 },
  { id: "shop", label: "Pazar", emoji: "🛍️", order: 3 },
  { id: "enter", label: "Argëtim", emoji: "🎬", order: 4 },
  { id: "health", label: "Shëndet", emoji: "💊", order: 5 },
  { id: "other", label: "Tjetër", emoji: "📦", order: 6 },
];

export const OTHER_CATEGORY_ID: CategoryId = "other";

export const catMap = (cats: Category[]): Record<string, Category> =>
  Object.fromEntries(cats.map((c) => [c.id, c]));

export const slugifyCategoryId = (label: string): string =>
  label
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 32);

export const todayLocalISO = (): string => {
  const d = new Date();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${d.getFullYear()}-${m}-${day}`;
};

export const fmt = (n: number): string =>
  "€" + n.toFixed(2).replace(/\.00$/, "");

export const fmtFull = (n: number): string => "€" + n.toFixed(2);

export const monthName = (d: Date): string =>
  d.toLocaleString(intlLocale(), { month: "long", year: "numeric" });

export function daysLeftInMonth(d: Date): number {
  const last = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  return last - d.getDate() + 1;
}
